import React from "react";
import logo from "../../shared/assets/images/logoFooter.svg";
import {useNavigate} from "react-router-dom";
import {useScrollToSection} from "../../shared/hook/useScrollToSection";
import S from './Footer.module.scss';

export const Footer = () => {
  const scrollToSection = useScrollToSection();
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <div className={S.footer} id='contacts'>
      <div className={S.container}>
        <div className={S.boxLogoEmail}>
          <div>
            <img src={logo} alt="Logo"/>
          </div>
          <div className={S.boxEmail}>
            <p>
              <a href="mailto:contact@bmksoft.info">contact@bmksoft.info</a>
            </p>
            <p>
              <a href="tel:+74942419311">+7 (4942) 41-93-11</a>
            </p>
            <span>Пн. - Пт. с 09:00 - 18:00</span>
          </div>
        </div>
        <div className={S.boxInfo}>
          <div className={S.boxMenu}>
            <div className={S.menuItems}>
              <div>Решения</div>
              <p onClick={() => scrollToSection('industries')}>ИТ-компаниям</p>
              <p onClick={() => scrollToSection('industries')}>промышленности</p>
              <p onClick={() => scrollToSection('industries')}>авиации</p>
            </div>
            <div className={S.menuItems}>
              <div>Продукты</div>
              <p onClick={() => scrollToSection('projects')}>БМК.ТОиР</p>
              <p onClick={() => scrollToSection('projects')}>БМК.ИТ</p>
              <p onClick={() => scrollToSection('projects')}>БМК.Платформа</p>
              <p onClick={() => scrollToSection('projects')}>БМК.ИИ-ассистенты</p>
              <p onClick={() => navigate('/product/Bench')}>Bench</p>
            </div>
            <div className={S.menuItems}>
              <div>О компании</div>
              <p onClick={() => scrollToSection('contacts')}>контакты</p>
              <p onClick={() => navigate('/accreditation-page')}>ИТ-аккредитация</p>
            </div>
          </div>
          <div className={S.divText}>
            <p>Почтовый адрес: 156000, г. Кострома, ул. Свердлова, д. 1<br/> Юр. Адрес: 156000, г. Кострома, ул.
              Смоленская, д. 12, кв. 3<br/>
              ИНН: 4400022528<br/>
              КПП: 440001001<br/>
              ОГРН: 1244400004672
            </p>
          </div>
        </div>
        <div className={S.basementText}>
          <div>
            <p>© ООО «БМК-СОФТ», 2025–{currentYear}</p>
          </div>
          <div className={S.divData}>
            <p onClick={() => navigate('/agreement')}>
              Согласие на обработку данных
            </p>
            <p onClick={() => navigate('/privacy-policy')}>Политика конфиденциальности</p>
          </div>
        </div>
      </div>
    </div>
  );
}